export default function createGetFormSyncWarnings(_ref) {
  var getIn = _ref.getIn,
      empty = _ref.empty;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };

      return getIn(nonNullGetFormState(state), form + ".syncWarnings") || empty;
    };
  };
}


//////////////////
// WEBPACK FOOTER
// ../~/redux-form/es/selectors/getFormSyncWarnings.js
// module id = 2141
// module chunks = 1